export default __webpack_public_path__ + "static/media/etc01.b21b24ea.png";